"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpecificSearchSelectWrapper = SpecificSearchSelectWrapper;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const Api = __importStar(require("@src/api"));
const useAppMutation_1 = require("@src/hooks/useAppMutation");
const antd_1 = require("antd");
const react_intl_1 = require("react-intl");
const SpecificSearchSelect_1 = require("./SpecificSearchSelect");
function SpecificSearchSelectWrapper({ selectedValues, setSelectedValues, isTagCountInLimit, handleSelect, onChange, }) {
    const intl = (0, react_intl_1.useIntl)();
    const [suggestedCompanies, setSuggestedCompanies] = react_1.default.useState([]);
    const { mutateAsync: suggestionsRefetch, isLoading: isFetching } = (0, useAppMutation_1.useAppMutation)(Api.Offers.getSearchSuggestions, {
        onSuccess: data => {
            const { companySuggestions } = data.suggestions;
            setSuggestedCompanies(companySuggestions);
        },
        onError: err => {
            console.error(err);
            antd_1.notification.error({
                message: intl.formatMessage({
                    id: 'general.error',
                }),
                description: intl.formatMessage({
                    id: 'general.something_went_wrong',
                }),
            });
        },
    });
    const getSearchSuggestions = (searchQuery) => {
        if (!searchQuery) {
            emptySuggestions();
            return;
        }
        suggestionsRefetch(searchQuery);
    };
    const emptySuggestions = () => {
        setSuggestedCompanies([]);
    };
    const defaultHandleSelect = (option) => {
        setSelectedValues([...(selectedValues || []), option]);
    };
    const defaultHandleDeselect = ({ label, value }) => {
        const newSelectedValues = (selectedValues || []).filter(({ label: itemLabel, value: itemValue }) => itemLabel !== label && itemValue !== value);
        setSelectedValues(newSelectedValues);
    };
    return ((0, jsx_runtime_1.jsx)(SpecificSearchSelect_1.SpecificSearchSelect, { selectedValues: selectedValues, onChange: onChange, getSearchSuggestions: getSearchSuggestions, isLoading: isFetching, emptySuggestions: emptySuggestions, suggestedCompanies: suggestedCompanies, isTagCountInLimit: isTagCountInLimit, handleSelect: handleSelect || defaultHandleSelect, handleDeselect: defaultHandleDeselect }));
}
